import axios from 'axios';

let config;
await fetch('data/nutribot/config.json')
  .then((response) => response.json())
  .then((json) => {
    config = json;
  })
  .catch((error) => {
    console.log('fetch data failed', error);
  });
const API_BASE_URL = config.apiUrl;

/**
 * Method to call the POST method that stats the topic and creates the openAI singleton for the respective details.
 * @param {String} topic Topic to search for.
 * @param {Array} years Years of searching.
 * @param {Number | null} userId user Id.
 * @param {Boolean} globalSearch If we are search all the pages or only in scientific magazines.
 * @returns Data of the request with the user and topic ID.
 */
export const initTopicRequest = async (topic, years, userId, globalSearch) => {
  const url = API_BASE_URL + config.endpoints.initTopic;
  const body = {
    topic: topic,
    years: years,
    userId: userId,
    globalSearch: globalSearch,
  };
  try {
    const response = await axios.post(url, body);
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Method to retrieve the OpenAI answer to the user question.
 * @param {String} question Question for OpenAI prompt.
 * @returns Response with the OpenAI answer.
 */
export const getAnswer = async (question) => {
  const url = API_BASE_URL + config.endpoints.qa;
  const body = {
    params: {
      question: question,
    },
  };
  try {
    const response = await axios.get(url, body);
    return response.data;
  } catch (error) {
    console.error("Error fetching bot answer:", error);
    throw error;
  }
};

/**
 * Method to retrieve the topics instantiated by the user.
 * @param {Number} userId User ID.
 * @returns Response with the topics details.
 */
export const getTopics = async (userId) => {
  const url = API_BASE_URL + config.endpoints.topics + '/' + userId;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Method to retrieve the documents used for the topic OpenAI Singleton construction.
 * @param {Number} userId User ID.
 * @param {Number} topicId Topic ID.
 * @returns Topic documents.
 */
export const getTopicDocuments = async (userId, topicId) => {
  const url = API_BASE_URL + config.endpoints.topicDocuments;
  const body = {
    params: {
      userId: userId,
      topicId: topicId,
    },
  };
  try {
    const response = await axios.get(url, body);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Method to retrieve the topics instantiated by the user.
 * @param {Number} userId User ID.
 * @param {Number} topicId Topic ID.
 * @returns Response with the topics details.
 */
export const getChatHistory = async (userId, topicId) => {
  const url = API_BASE_URL + config.endpoints.chatHistory + '?userId=' + userId + '&topicId=' + topicId;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Method to verify if an user is valid.
 * @param {Number} userId User ID.
 */
export const verifyUser = async (userId) => {
  const url = API_BASE_URL + config.endpoints.userValidation + '/' + userId;
  try {
    await axios.post(url);
  } catch (error) {
    if (error.response.status === 410) {
      localStorage.removeItem('userId');
      window.location.reload();
    }
    throw error;
  }
};

/**
 * Method to remove a topic from the user database.
 * @param {Number} userId User ID.
 * @param {Number} topicId Topic ID.
 */
export const removeTopic = async (userId, topicId) => {
  const url = API_BASE_URL + config.endpoints.removeTopic + '?userId=' + userId + '&topicId=' + topicId;
  try {
    await axios.post(url);
  } catch (error) {
    throw error;
  }
};

/**
 * Method to remove a topic from the user database.
 * @param {Number} userId User ID.
 */
export const logout = async (userId) => {
  const url = API_BASE_URL + config.endpoints.logoutUser + '/' + userId;
  try {
    await axios.post(url);
    localStorage.removeItem('userId');
    window.location.reload();
  } catch (error) {
    throw error;
  }
};
